<template>
<div>
    <!-- BradCrumb header Start-->
    <section class="main-header bg-header main-page-banner-img">
        <div class="home-bg-img">
            <div class="container">
                <div class="owl-carousel owl-theme main-slider owl-loaded owl-drag">
                    <div class="owl-stage-outer">
                        <div class="owl-stage" style="transform: translate3d(-1388px, 0px, 0px); transition: all 0s ease 0s; width: 2430px;">

                            <div class="owl-item active" style="width: 347.1px;">
                                <div class="item">
                                    <div class="row align-items-center">
                                        <div class="col-lg-7">
                                            <div data-wow-delay="0.1s" data-wow-duration="1s" class="content wow fadeInUp" style="visibility: visible; animation-duration: 1s; animation-delay: 0.1s;">
                                                <h2 class="banner-title text-lg-left text-center text-white text-uppercase"> ANCHOR GROUP CORP<br>ASSESSMENTS </h2>
                                                <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16"> The Anchor assessments examine the level of maturity of an organization is crucial strategic and functional areas. The Assessments are built on a circular principle that great organizations continuously evaluate, measure, and tweak.
                                                    We leverage the philosophy that an organization that wins establishes a comprehensive plan and KPIs, assigns the appropriate teams to manage and execute these plans, tracks, and report on the level of success, and establishes the adequate mechanisms to re-align from deviation. </p>
                                                <div class="mt-md-4 mb-4 text-lg-left text-center"><a href="#assessments-list" class="btn theme-btn text-white">GET STARTED NOW</a></div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div data-wow-delay="0.3s" data-wow-duration="1s" class="banner-img-02 wow fadeInUp" style="visibility: visible; animation-duration: 1s; animation-delay: 0.3s;"><img src="assets/images/main-banner-01.png" alt="" class="img-fluid"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- portfolio Grid-col-5 Start -->
    <section id="assessments-list" class="section portfolio-section grid-col-5">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-12 wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="title-section">
                        <h2 class="text-capitalize text-center">Check out the assessments we offer</h2>
                        <!-- <p class="text-center font-weight-regular grey-text mt-4 mb-0">
                                Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar.
                            </p> -->
                    </div>
                </div>
            </div>
            <div class="filters portfolio-filter my-5 text-center wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                <ul class="p-0 list-unstyled d-flex align-items-center justify-content-center flex-wrap">
                    <li class="active py-3 mx-3" data-filter="*">All</li>
                    <li class="py-3 mx-3" data-filter=".Security">Security</li>
                    <li class="py-3 mx-3" data-filter=".Corporate">Corporate</li>
                    <li class="py-3 mx-3" data-filter=".Health">Health Care</li>
                </ul>
            </div>

            <div class="filters-content wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1s">
                <div class="row portfolio-items grid-5">

                    <template v-for="assessment in assessments">
                        <div :class="assessment.type" :key="assessment.name">
                            <div class="item shadow text-center port-item">
                                <img :src="assessment.image" alt="Work 1" class="img-fluid">
                                <!-- <div class="magnific-icon">
                                    <a href="assets/images/portfolio/p-1.jpg" class="js-zoom-gallery"> <i class="mdi mdi-magnify-plus-outline"></i> </a>
                                </div> -->
                                <div class="portfolio-hover">
                                    <h5 class="text-capitalize title-01">
                                        <a :href="assessment.link" class="green-color"> Get started now</a>
                                    </h5><br>
                                </div>
                                <h5 style="margin-top:10px;">{{assessment.name}}</h5>
                            </div>

                        </div>
                    </template>

                </div>
            </div>
        </div>
    </section>
    <!-- portfolio Grid-col-5 End -->

    <steps></steps>

    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-baseline">
                <faqs></faqs>

                <div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">ASSESS YOURSELF TODAY</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-20">We Are Commited To Helping You Grow</h2>
                    </div>
                    <div class="mt-6">
                        <div id="accordion" class="wow fadeInUp" data-wow-duration="1500ms">
                          
                                <div class="row align-items-center">
                                    <div class="col-lg-40"><img src="assets/images/assessments/main-page-side-img.jpeg" alt="main-page-side-image.jpg" class="w-100 img-fluid"></div>
                                </div>
                           
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <promotions></promotions>
    <contact-form></contact-form>

</div>
</template>

<script>
//ISOTOP JS
import '../../assets/js/jquery.isotope.min.js';
//MAGNIFIC POPUP JS
import 'magnific-popup/dist/jquery.magnific-popup.min.js';
import 'magnific-popup/dist/magnific-popup.css';
import ContactForm from '../layouts/contactForm.vue';
import Faqs from '../layouts/faqs.vue';
import Promotions from '../layouts/promotions.vue';
import Steps from '../layouts/steps.vue';

import {
    assessmentsList
} from '../landing-pages/assessmentListing';

export default {
    name: 'portfolio',
    components: {
        Steps,
        ContactForm,
        Promotions,
        Faqs,

    },

    mounted() {
        this.init();
    },
    data() {
        return {
            assessments: assessmentsList
        }
    },
    methods: {
        init() {
            this.initIsotop();
            this.initMainSlider();
            this.initClientSlider();
            this.initMagnificPopup();
        },
        /*----Main Slider----*/
        initMainSlider() {
            $('.main-slider').owlCarousel({
                loop: true,
                items: 1,
                margin: 0,
                nav: true,
                dots: true,
                autoplay: false,
                autoplayTimeout: 5000,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    600: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    1000: {
                        items: 1,
                        nav: false,
                        dots: true
                    }
                }
            });
        },

        /*----CLIENT SLIDER-----*/
        initClientSlider() {
            var testimonialCarousel = $('.clients-slider');
            if (testimonialCarousel.length > 0) {
                testimonialCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $('.wow').length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----ISOTOP JS-----*/
        initIsotop() {
            var $container = $('.portfolio-items');
            $container.imagesLoaded(function () {
                $container.isotope({
                    filter: '*',
                    animationOptions: {
                        duration: 750,
                        easing: 'linear',
                        queue: false
                    }
                });
            });

            $('.portfolio-filter li').click(function () {
                $('.portfolio-filter .current').removeClass('current');
                $(this).addClass('current');
                var selector = $(this).attr('data-filter');
                $container.isotope({
                    filter: selector,
                    animationOptions: {
                        duration: 750,
                        easing: 'linear',
                        queue: false
                    }
                });
                return false;
            });
        },
        /*----MAGNIFIC POPUP JS-----*/
        initMagnificPopup() {
            if (('.portfolio-items').length > 0) {
                $('.portfolio-items').each(function () {
                    $(this).magnificPopup({
                        delegate: '.js-zoom-gallery',
                        type: 'image',
                        gallery: {
                            enabled: true
                        }
                    });
                });
            }
        }
    }
}
</script>
